<div class="page-display">
  <app-page-header-display [page]="page$ | async"></app-page-header-display>
  <div class="container">
    <div class="row">
      <app-page-display [page]="page$ | async"></app-page-display>
    </div>
  </div>
</div>
